import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

import { ToolbarSection, ToolbarItem } from '../../editor';
import { ToolbarRadio } from '../../editor/Toolbar/ToolbarRadio';

const useStyles = makeStyles((theme) => ({
  colorPreviewWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  colorBox: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: '50%',
    boxShadow: theme.shadows[1], 
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  colorBoxText: {
    width: '100%',
    textAlign: 'center',
    fontWeight: 'bold',
  },
}));

export const ContainerSettings = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <ToolbarSection
        title="Dimensiones"
        props={['width', 'height']}
        summary={({ width, height }) => {
          return `${width || 0} x ${height || 0}`;
        }}
      >
        <ToolbarItem propKey="width" type="text" label="Ancho" /> 
        <ToolbarItem propKey="height" type="text" label="Alto" />
      </ToolbarSection>
      <ToolbarSection
        title="Colores"
        props={['background', 'color']}
        summary={({ background, color }) => {
          return (
            <div className={classes.colorPreviewWrapper}>
              <Box
                className={classes.colorBox}
                style={{
                  backgroundColor: background && `rgba(${Object.values(background)})`,
                }}
              >
                <p
                  className={classes.colorBoxText}
                  style={{ color: color && `rgba(${Object.values(color)})` }}
                >
                  T
                </p>
              </Box>
            </div>
          );
        }}
      >
        <ToolbarItem
          full={true}
          propKey="background"
          type="bg"
          label="Fondo"
        />
        <ToolbarItem full={true} propKey="color" type="color" label="Texto" />
      </ToolbarSection>
      <ToolbarSection title="Alineación">
        <ToolbarItem propKey="flexDirection" type="radio" label="Dirección (Flex)">
          <ToolbarRadio value="row" label="Fila" />
          <ToolbarRadio value="column" label="Columna" />
        </ToolbarItem>
        <ToolbarItem propKey="fillSpace" type="radio" label="Rellenar espacio">
          <ToolbarRadio value="yes" label="Sí" />
          <ToolbarRadio value="no" label="No" />
        </ToolbarItem>
        <ToolbarItem propKey="alignItems" type="radio" label="Alinear Elementos">
          <ToolbarRadio value="flex-start" label="Inicio" />
          <ToolbarRadio value="center" label="Centro" />
          <ToolbarRadio value="flex-end" label="Fin" />
        </ToolbarItem>
        <ToolbarItem
          propKey="justifyContent"
          type="radio"
          label="Justificar Contenido"
        >
          <ToolbarRadio value="flex-start" label="Inicio" />
          <ToolbarRadio value="center" label="Centro" />
          <ToolbarRadio value="flex-end" label="Fin" />
        </ToolbarItem>
      </ToolbarSection>
      <ToolbarSection
        title="Márgenes"
        props={['margin']}
        summary={({ margin }) => {
          return `${margin[0] || 0}px ${margin[1] || 0}px ${margin[2] || 0}px ${margin[3] || 0}px`;
        }}
      >
        <ToolbarItem propKey="margin" index={0} type="slider" label="Superior" />
        <ToolbarItem propKey="margin" index={1} type="slider" label="Derecho" />
        <ToolbarItem propKey="margin" index={2} type="slider" label="Inferior" />
        <ToolbarItem propKey="margin" index={3} type="slider" label="Izquierdo" />
      </ToolbarSection>
      <ToolbarSection
        title="Relleno"
        props={['padding']}
        summary={({ padding }) => {
          return `${padding[0] || 0}px ${padding[1] || 0}px ${padding[2] || 0}px ${padding[3] || 0}px`;
        }}
      >
        <ToolbarItem propKey="padding" index={0} type="slider" label="Superior" />
        <ToolbarItem propKey="padding" index={1} type="slider" label="Derecho" />
        <ToolbarItem propKey="padding" index={2} type="slider" label="Inferior" />
        <ToolbarItem propKey="padding" index={3} type="slider" label="Izquierdo" />
      </ToolbarSection>
      <ToolbarSection title="Decoración" props={['radius', 'shadow']}>
        <ToolbarItem
          full={true}
          propKey="radius"
          type="slider"
          label="Radio de Borde"
        />
        <ToolbarItem
          full={true}
          propKey="shadow"
          type="slider"
          label="Sombra"
        />
      </ToolbarSection>
    </React.Fragment>
  );
};